/* eslint-disable */
import React from 'react'
import _ from 'lodash'
import PropTypes from "prop-types"
import Select from "react-select";
import InputMask from "react-input-mask";

export const InputTemplate = ({
  isSelect,
  isInputMask,
  containerClassName,
  labelClassName,
  actionButtonContainerClass,
  htmlFor,
  title,
  badge,
  isTitleTruncate,
  formValidatorMsg,
  withActionButton,
  withCheckBoxComponent,
  withCustomInputComponent,
  ...inputprops
}) => {

  return (
    <div className={`form-input-group-v2 my-1 ${containerClassName}`}>
      {title && (
        <label
          htmlFor={htmlFor}
          className={`full-label-v2 mb-0 ${labelClassName}`}
          style={{ opacity: ".7" }}
        >
          <div className="row w-100 p-0 m-0">
           <div className={`col-sm-12 order-2 ${!_.isEmpty(withCheckBoxComponent()) && 'col-lg-7 order-lg-2'} m-0 py-1 px-0  ${isTitleTruncate && "text-truncate"}`}>
            {title}{" "}{
              badge && (
                <span className="badge rounded-pill bg-success text-white animated flash">
                {badge}
              </span>
              )
            } {formValidatorMsg || ""}{" "}
           </div>
            {!_.isEmpty(withCheckBoxComponent()) && (
              <div className="col-sm-12 order-1 col-lg-5 order-lg-2 m-0 py-1 px-0 ">
                { withCheckBoxComponent() }
              </div>
            )}
          </div>
        </label>
      )}
      {
        !title && formValidatorMsg && 
          <label
            htmlFor={htmlFor}
            className={`full-label mb-0 ${labelClassName}`}
            style={{ opacity: ".7" }}
          >
            {formValidatorMsg}
          </label>
      }
      
      {_.isEmpty(withActionButton()) && (
        <>
          {/* // TODO: refactor nested ternary operator later :D */}
          {isSelect && !isInputMask && _.isEmpty(withCustomInputComponent()) && <Select {...inputprops} />}
          {isInputMask && !isSelect && _.isEmpty(withCustomInputComponent()) && <InputMask {...inputprops} />}
          {!_.isEmpty(withCustomInputComponent()) && !isSelect && !isInputMask && withCustomInputComponent()}
          {(!isSelect && !isInputMask && _.isEmpty(withCustomInputComponent())) && <input {...inputprops} />}
          
          {/* render custom action button*/}
          {!_.isEmpty(withActionButton()) && withActionButton()}
        </>
      )}

      {/* render input component with action button*/}
      {!_.isEmpty(withActionButton()) && (
        <div className={`form-input-group-v2 d-flex w-100 border ${actionButtonContainerClass}`} style={{ borderRadius: "7px", overflow: "hidden" }}>
        {/* // TODO: refactor nested ternary operator later :D */}
          {isSelect && !isInputMask && _.isEmpty(withCustomInputComponent()) && <Select {...inputprops} />}
          {isInputMask && !isSelect && _.isEmpty(withCustomInputComponent()) && <InputMask {...inputprops} />}
          {!_.isEmpty(withCustomInputComponent()) && !isSelect && !isInputMask && withCustomInputComponent()}
          {(!isSelect && !isInputMask && _.isEmpty(withCustomInputComponent())) && <input {...inputprops} />}
          
          {/* render custom action button*/}
          {!_.isEmpty(withActionButton()) && withActionButton()}
        </div>
      )}
    </div>
  );
};

InputTemplate.defaultProps = {
  isSelect: false,
  isInputMask: false,
  containerClassName: "",
  labelClassName: "",
  actionButtonContainerClass: "",
  htmlFor: "",
  title: "",
  isTitleTruncate: false,
  formValidatorMsg: "",
  inputprops: "",
  withActionButton: () => {},
  withCheckBoxComponent: () => {},
  withCustomInputComponent: () => {},
};

InputTemplate.propTypes = {
  isSelect: PropTypes.bool,
  isInputMask: PropTypes.bool,
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  actionButtonContainerClass: PropTypes.string,
  htmlFor: PropTypes.string,
  title: PropTypes.string,
  isTitleTruncate: PropTypes.bool,
  formValidatorMsg: PropTypes.node,
  inputprops: PropTypes.node,
  withActionButton: PropTypes.instanceOf(Function),
  withCheckBoxComponent: PropTypes.instanceOf(Function),
  withCustomInputComponent: PropTypes.instanceOf(Function),
};

export const RadioButtonTemplate = ({
  title,
  htmlFor,
  formValidatorMsg,
  withOthers,
  othersinputprops,
  containerClassName,
  ...inputprops
}) => {
  return (
    <div className={`d-flex align-items-center ${containerClassName}`}>
      <input {...inputprops} />
      <label htmlFor={htmlFor} className="full-label mb-0 mx-1">
        {title} {formValidatorMsg || ""}{" "}
      </label>
      {withOthers && <input {...othersinputprops} />}
    </div>
  );
};

RadioButtonTemplate.defaultProps = {
  htmlFor: "",
  title: "",
  containerClassName: "",
  badge: "",
  inputprops: "",
  othersinputprops: "",
  formValidatorMsg: "",
  withOthers: false,
};

RadioButtonTemplate.propTypes = {
  htmlFor: PropTypes.string,
  title: PropTypes.string,
  containerClassName: PropTypes.string,
  badge: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  inputprops: PropTypes.node,
  othersinputprops: PropTypes.node,
  formValidatorMsg: PropTypes.node,
  withOthers: PropTypes.bool,
};